import { z } from "zod";

export const CursorQuerySchema = z.object({
  pageSize: z.coerce.number().int().min(1).max(200).default(50),
  pageToken: z.string().min(1).optional(),
});

export const PageMetadataSchema = z.object({
  nextPageToken: z.string().min(1).optional(),
  totalSize: z.number().int().min(0).optional(),
});

export type CursorQuery = z.infer<typeof CursorQuerySchema>;
export type PageMetadata = z.infer<typeof PageMetadataSchema>;
